import customAxios from '../interceptors';

const updateUser = (userID: string, params: any) => {
  return customAxios.put(`${process.env.REACT_APP_API_URL}/users/${userID}`, {
    ...params
  });
}

export default updateUser;
